// The padding <main> gives every page (Layout.tsx), and the matching padding the AI hub's tab bar needs on the
// Chat route.
//
// Layout drops <main>'s padding on chat routes so the chat can run edge to edge and scroll internally. The hub's
// tab bar then lives outside any padded container, so AIHub pads it itself. If that padding differs from
// <main>'s, the tab row visibly jumps (24px down, 16px right at xl) every time you switch between Chat and
// another AI tab. Both strings live here, and contentPadding.test.ts pins that the second is the top-and-sides
// part of the first at every breakpoint.
export const MAIN_CONTENT_PADDING = 'p-6 lg:p-8 xl:p-10'

export const CHAT_HUB_TAB_PADDING = 'px-6 pt-6 lg:px-8 lg:pt-8 xl:px-10 xl:pt-10'
